/** axios 등 비-Vue 코드에서 App.vue의 세션 만료 다이얼로그를 띄울 때 사용 */

let opener = null
let gateOpen = false
// 이 페이지를 연 뒤 토큰을 실은 API 가 한 번이라도 통했나.
// 한 번도 못 통했으면 들고 온 토큰이 처음부터 무효였던 것이다(서명 키 교체 등) - 하던 일이 없으니
// 모달 없이 로그인으로 보낸다. 통한 뒤에 끊기면 쓰던 중이니 모달로 알린다.
let sessionConfirmed = false

export function registerSessionExpiredDialog(fn) {
  opener = typeof fn === 'function' ? fn : null
}

export function unregisterSessionExpiredDialog() {
  opener = null
}

export function markSessionConfirmed() {
  sessionConfirmed = true
}

/** 로그인이 끊겼을 때(401 뒤 갱신 실패 등): 안내 모달 요청 (연속 요청 시 한 번만) */
export function requestSessionExpiredDialog() {
  if (gateOpen) return
  gateOpen = true
  if (opener) opener({ silent: !sessionConfirmed })
}

export function resetSessionExpiredDialogGate() {
  gateOpen = false
}
